/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddedLocation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TagTextDelete from 'DesignSystem/TagTextDelete/index'



/** @type {import('Simple/types.js').View} */
export default function AddedLocation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/Locations/Content/AddedLocation"
  
}) {
let selectedLocationTextValueData = fromData.useDataValue({ viewPath,
context: 'selected_location',
path: 'text',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TagTextDelete
  viewPath={`${viewPath}/TagTextDelete`}
 data="selected_location.text"
 text={selectedLocationTextValueData}
 onClick={onClick}
/>
{children}
</React.Fragment>)
}